import {onBeforeUnmount, watch} from 'vue'
import {useAuthStore} from '@/stores/auth.store'
import {onDownloadEvents} from '@/events/downloadEvents'

/** Export completion follows the signed-in account across editor and dashboard routes. */
export function useDownloadEvents() {
    const auth = useAuthStore()
    const stop = watch(() => auth.isLoggedIn ? auth.user.id : null, (userId, _previous, onCleanup) => {
        if (userId != null) onCleanup(onDownloadEvents())
    }, {immediate: true, flush: 'sync'})

    onBeforeUnmount(stop)
}
